import type { ReactNode } from 'react';
import { useCurrentUser } from '@/hook/useCurrentUser';

interface AdminOnlyProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Renders `children` only when the server-resolved user is an admin. Renders
 * nothing while loading (no flash). UX guard only — every authoring mutation is
 * independently `requireAdmin`-guarded server-side.
 */
export function AdminOnly({ children, fallback = null }: AdminOnlyProps) {
  const { isAdmin, isLoading } = useCurrentUser();
  if (isLoading) return null;
  return <>{isAdmin ? children : fallback}</>;
}
